<template>
  <div>
    <Topbar
      v-if="tutorial"
      :title="tutorial.title"
      :content="tutorial.content"
    />

    <Bg />

    <div v-if="utente" class="panel">
      <!-- COFFERS GRID-->
      <ul class="grid grid--coffers">
        <li
          v-for="forziere in forzieri"
          :key="forziere"
          class="coffer coffer--bronze"
        >
          <div class="coffer__content">
            <div v-for="cofferItem in utente.forzieri" :key="cofferItem">
              <button
                v-if="forziere.id === cofferItem"
                class="coffer__close"
                @click="handleDelete(forziere.id, forziere.op)"
              >
                <i class="bx bx-x"></i>
              </button>
            </div>

            <div class="coffer__points ommepoints">
              <div v-for="fascia in fasce" :key="fascia">
                <div
                  v-if="
                    utente.opStart >= fascia.opStart.min &&
                      utente.opStart <= fascia.opStart.max
                  "
                >
                  <div
                    ref="forziereOp"
                    v-if="
                      forziere.id === 'bronzo-4' ||
                        forziere.id === 'argento-10' ||
                        forziere.id === 'oro-10'
                    "
                  >
                    {{ (forziere.op = fascia.forzieri[0]) }}
                  </div>

                  <div
                    ref="forziereOp"
                    v-if="
                      forziere.id === 'bronzo-8' ||
                        forziere.id === 'argento-12' ||
                        forziere.id === 'oro-15'
                    "
                  >
                    {{ (forziere.op = fascia.forzieri[1]) }}
                  </div>

                  <div
                    ref="forziereOp"
                    v-if="
                      forziere.id === 'bronzo-10' ||
                        forziere.id === 'argento-15' ||
                        forziere.id === 'oro-20'
                    "
                  >
                    {{ (forziere.op = fascia.forzieri[2]) }}
                  </div>
                </div>
              </div>
            </div>

            <img
              v-if="
                forziere.id === 'bronzo-4' ||
                  forziere.id === 'bronzo-8' ||
                  forziere.id === 'bronzo-10'
              "
              class="coffer__icon"
              src="@/assets/images/icons/icon-coffer-bronze.svg"
            />

            <img
              v-if="
                forziere.id === 'argento-10' ||
                  forziere.id === 'argento-12' ||
                  forziere.id === 'argento-15'
              "
              class="coffer__icon"
              src="@/assets/images/icons/icon-coffer-silver.svg"
            />

            <img
              v-if="
                forziere.id === 'oro-10' ||
                  forziere.id === 'oro-15' ||
                  forziere.id === 'oro-20'
              "
              class="coffer__icon"
              src="@/assets/images/icons/icon-coffer-gold.svg"
            />
          </div>
          <div class="coffer__price">
            <div>{{ forziere.prezzo }}€</div>
            <div>
              <button
                class="coffer__cart"
                @click="handleSubmit(forziere.id, forziere.op)"
              >
                <i class="bx bx-cart-alt"></i>
              </button>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- COFFERS CART -->
    <section class="shop-total">
      <div class="shop-total__counter">
        Totale
        <div>
          <i class="bx bx-cart-alt"></i>
          <span v-if="utente">{{ utente.forzieri.length }}</span>
        </div>
      </div>
      <div class="shop-total__btn">
        <router-link :to="{ name: 'Services' }" class="btn btn--primary"
          >I vostri servizi</router-link
        >
      </div>
    </section>
  </div>
</template>

<script>
import getUser from '@/composables/getUser'
import getCollection from '@/composables/getCollection'
import getDocument from '@/composables/getDocument'
import useDocument from '../composables/useDocument'

import { projectFirestore } from '../firebase/config'
import firebase from 'firebase/app'
import { ref } from 'vue'

import Bg from '@/components/Bg.vue'
import Topbar from '@/components/Topbar.vue'

export default {
  components: { Bg, Topbar },
  setup() {
    const { user } = getUser()
    const { error, document: utente } = getDocument('utenti', user.value.uid)

    const { document: tutorial } = getDocument('tutorial', 'forzieri')

    const { documents: forzieri } = getCollection('forzieri', '', 'prezzo')

    const { documents: fasce } = getCollection(
      'fasce-prezzo',
      '',
      'opStart.min'
    )

    const forziereOp = ref(null)

    const { updateDoc } = useDocument('utenti', user.value.uid)

    const handleSubmit = async (forziere, op) => {
      let res = await updateDoc({
        forzieri: firebase.firestore.FieldValue.arrayUnion(forziere),
        opTotal: firebase.firestore.FieldValue.increment(op),
        forzieriTotal: firebase.firestore.FieldValue.increment(op),
        sconti: firebase.firestore.FieldValue.arrayUnion(30),
      })

      if (
        forziere === 'bronzo-4' ||
        forziere === 'bronzo-8' ||
        forziere === 'bronzo-8'
      ) {
        res = await updateDoc({
          forzieriBronzo: firebase.firestore.FieldValue.increment(1),
        })
      }

      if (
        forziere === 'argento-10' ||
        forziere === 'argento-12' ||
        forziere === 'argento-15'
      ) {
        res = await updateDoc({
          forzieriArgento: firebase.firestore.FieldValue.increment(1),
        })
      }

      if (
        forziere === 'oro-10' ||
        forziere === 'oro-15' ||
        forziere === 'oro-20'
      ) {
        res = await updateDoc({
          forzieriOro: firebase.firestore.FieldValue.increment(1),
        })
      }
    }

    const handleDelete = async (forziere, op) => {
      const res = await updateDoc({
        forzieri: firebase.firestore.FieldValue.arrayRemove(forziere),
        opTotal: firebase.firestore.FieldValue.increment(-op),
        forzieriTotal: firebase.firestore.FieldValue.increment(-op),
      })
    }

    return {
      forzieri,
      utente,
      fasce,
      handleSubmit,
      handleDelete,
      forziereOp,
      tutorial,
    }
  },
}
</script>

<style scoped>
.panel {
  margin-top: 8rem;
}
</style>
